// extracted by mini-css-extract-plugin
module.exports = {"container":"PoAddressDetails_container__3Su5L","title":"PoAddressDetails_title__3t4me","input":"PoAddressDetails_input__Rn9JF"};